<template>
  <div class="section-search filter-section py-5">
    <div class="container">
      <!-- Title -->
      <h2 class="filter-title text-center mb-4">ما الذي تبحث عنه؟</h2>

      <!-- Search Bar -->
      <div class="search-bar mb-3">
        <input 
          type="text" 
          class="form-control search-input" 
          placeholder="ابحث عن سيارة..." 
          v-model="searchText"
        />
        <i class="fa fa-search search-icon"></i>
      </div>

      <!-- Availability Switch -->
      <div class="availability mb-3">
        <label class="form-check-label">التوفر</label>
        <label class="switch">
          <input type="checkbox" v-model="isAvailable" />
          <span class="slider round"></span>
        </label>
      </div>

      <!-- Accordion Filters -->
      <div class="accordion mb-4" id="filters">
        <div
          v-for="(filter, index) in filters"
          :key="index"
          class="accordion-item"
        >
          <h2 class="accordion-header">
            <button
              class="accordion-button collapsed justify-content-between text-end"
              type="button"
              data-bs-toggle="collapse"
              :data-bs-target="'#collapse' + index"
              aria-expanded="false"
              :aria-controls="'collapse' + index"
            >
              <span>{{ filter.title }}</span>
            </button>
          </h2>
          <div
            :id="'collapse' + index"
            class="accordion-collapse collapse"
            data-bs-parent="#filters"
          >
            <div class="accordion-body">
              <!-- select -->
              <div v-if="filter.useSelect">
                <select 
                  class="form-select mb-2" 
                  v-model="selectedFilters[filter.key]"
                >
                  <option value="">اختر {{ filter.title }}</option>
                  <option 
                    v-for="(option, optIndex) in filter.options" 
                    :key="optIndex" 
                    :value="option"
                  >
                    {{ option }}
                  </option>
                </select>
              </div>

              <!-- checkboxes -->
              <div v-else>
                <div class="form-check mb-2" 
                     v-for="(option, optIndex) in filter.options" 
                     :key="optIndex"
                >
                  <input 
                    class="form-check-input" 
                    type="checkbox" 
                    :id="`check-${index}-${optIndex}`" 
                    :value="option"
                    v-model="selectedFilters[filter.key]"
                  />
                  <label class="form-check-label ms-2" :for="`check-${index}-${optIndex}`">
                    {{ option }}
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Action Buttons -->
      <div class="d-flex justify-content-center gap-3">
        <button 
          class="btn btn-search"
          @click="handleSearch()"
        >
          <i class="fa fa-search me-2"></i> بحث
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { useCarsStore } from "@/stores/cars-store";

export default {
  name: "CustomSearch",
  data() {
    return {
      searchText: "",
      isAvailable: true,
      filters: [
        { 
          key: "brand_name", 
          title: "نوع السيارة", 
          options: [
            "Acura","Alfa Romeo","Aston Martin","Audi","BMW","BYD","Buick","Cadillac","Chrysler","Daewoo",
            "Daihatsu","Dodge","Fiat","Ford","GAC","GMC","Genesis","Honda","Hummer","Hyundai","Infiniti",
            "Isuzu","Jaguar","Jeep","Kia","Land Rover","Lexus","Lincoln","MINI","Mazda","Mercedes-Benz",
            "Mercury","Mitsubishi","Nissan","Opel","Peugeot","Pontiac","Porsche","Proton","Renault",
            "Skoda","Subaru","Suzuki","Toyota","Volkswagen","Volvo","others"
          ],
          useSelect: true, // more → select
        },
        { 
          key: "year_from", 
          title: "سنة الصنع", 
          options: [
            "1980","1981","1982","1983","1984","1985","1986","1987","1988","1989",
            "1990","1991","1992","1993","1994","1995","1996","1997","1998","1999",
            "2000","2001","2002","2003","2004","2005","2006","2007","2008","2009",
            "2010","2011","2012","2013","2014","2015","2016","2017","2018","2019",
            "2020","2021","2022","2023","2024","2025"
          ],
          useSelect: true, // more → select
        },
        { 
          key: "fuel_type", 
          title: "الوقود", 
          options: ["بنزين", "ديزل", "كهرباء", "هايبرد"],
          useSelect: false, // less → checkboxes
        },
        { 
          key: "type", 
          title: "فئة السيارة", 
          options: ["سيدان", "SUV", "هاتشباك", "دفع رباعي", "كوبيه", "فان"],
          useSelect: false, // less → checkboxes
        },
      ],
      selectedFilters: {
        brand_name: "",
        year_from: "",
        fuel_type: [],
        type: [],
      },
    };
  },
  setup() {
    const carsStore = useCarsStore();
    return { carsStore };
  },
  methods: {
    handleSearch() {
      const filters = {
        search: this.searchText,
        rent_or_sale: this.isAvailable ? "sale" : "",
        brand_name: this.selectedFilters.brand_name,
        year_from: this.selectedFilters.year_from,
        fuel_type: this.selectedFilters.fuel_type.join(","),
        type: this.selectedFilters.type.join(","),
      };
      console.log("Filters applied:", filters);
      Object.entries(filters).forEach(([k, v]) => {
        if (v) this.carsStore.setFilter(k, v);
      });
      this.carsStore.fetchCars();
      this.$router.push("/listing/listing-grid");
    },
  },
};
</script>


<style scoped>
.section-search {
  background-color: white;
  padding: 60px 0;
  z-index: 1;
  position: absolute;
  left: 50%;
  top: 90%;
  transform: translateX(-50%);
  width: 80%;
  box-shadow: 0 35px 80px rgba(0, 128, 0, 0.25); 
  border-radius: 20px;
}

.filter-title {
  color: #00a35c; 
  font-weight: bold;
  font-size: 1.5rem;
}

.search-bar {
  position: relative;
  width: 100%;
}
.search-input {
  border-radius: 8px;
  padding-right: 40px;
  background: #eafaf2; 
  border: 1px solid #00c569;
  height: 50px;
}
.search-icon {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 15px;
  color: #00c569;
}

.availability {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #00a35c;
  font-weight: 600;
}

/* Switch style */
.switch {
  position: relative;
  display: inline-block;
  width: 46px;
  height: 24px;
}
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #a3e3cb;
  transition: 0.4s;
  border-radius: 34px;
}
.slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: 0.4s;
  border-radius: 50%;
}
input:checked + .slider {
  background-color: #00c569;
}
input:checked + .slider:before {
  transform: translateX(22px);
}

.accordion-item {
  background-color: #eafaf2;
  border-radius: 8px;
  margin-bottom: 10px;
  border: 1px solid #00c569;
}
.accordion-button {
  background-color: #eafaf2;
  color: #00a35c;
  font-weight: bold;
  box-shadow: none;
  display: flex;
  justify-content: space-between; 
  align-items: center;
}
.accordion-button::after {
  transform: rotate(180deg);
  filter: hue-rotate(90deg); /* يخلي السهم لونه يميل للأخضر */
  margin: 0;
}
.accordion-button.collapsed::after {
  transform: rotate(0deg);
  margin-left: 0px;
}

.btn-search {
  background-color: #00c569;
  color: white;
  padding: 10px 20px;
  border-radius: 8px;
  font-weight: bold;
  border: none;
}

@media (max-width: 600px) {
  .section-search {
    width: 90%;
  }
}
</style>
